import type AssetBooking from '@/classes/assetBooking'

/**
 * Sorts the given bookings so that the booking closest to today is first
 *
 * @param {AssetBooking[]} bookings the bookings to sort
 * @returns {AssetBooking[]} the sorted bookings
 *
 * @throws {Error} if the input is not an array of bookings
 * @throws {Error} if any of the bookings does not have a `start_date` property
 */
export function sortBookingsByProximityToCurrentDate(bookings: AssetBooking[]): AssetBooking[] {
  // Check that the input is an array
  if (!Array.isArray(bookings)) {
    throw new Error('Input must be an array of bookings. The input type is: ' + typeof bookings)
  }

  // Sort the array
  const sortedData = bookings.sort((a, b) => {
    // Check that both objects have a start_date property
    if (!a.start_date || !b.start_date) {
      throw new Error(
        'Booking must have a start_date property. ' +
          'The start_date properties of the bookings are: ' +
          JSON.stringify({ a: a.start_date, b: b.start_date }),
      )
    }

    // Compare the start_date properties
    const dateA = new Date(a.start_date)
    const dateB = new Date(b.start_date)
    const now = new Date()
    const diffA = Math.abs(now.getTime() - dateA.getTime())
    const diffB = Math.abs(now.getTime() - dateB.getTime())
    return diffA - diffB
  })
  return sortedData
}
